import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=87a91170&scoped=true"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"
import style0 from "./Users.vue?vue&type=style&index=0&id=87a91170&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a91170",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87a91170')) {
      api.createRecord('87a91170', component.options)
    } else {
      api.reload('87a91170', component.options)
    }
    module.hot.accept("./Users.vue?vue&type=template&id=87a91170&scoped=true", function () {
      api.rerender('87a91170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/Users.vue"
export default component.exports